// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant, { Toast, Notify, Swipe, SwipeItem, Slider, Lazyload, Overlay, ImagePreview } from 'vant'
import 'vant/lib/index.css'

import 'lib-flexible'
import '@/style/reset.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import VueWechatTitle from 'vue-wechat-title'

import 'vant/lib/toast/style'
import 'vant/lib/notify/style'
import VueLazyload from 'vue-lazyload'
import axios from 'axios'
import '@/assets/css/common.css'
import VideoPlayer from 'vue-video-player'
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
// import Vconsole from 'Vconsole'
// const vConsole = new Vconsole();
// Vue.use(vConsole)

Vue.prototype.axios = axios

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)

Vue.use(VueWechatTitle)
Vue.use(Vant)
Vue.use(ImagePreview)
Vue.use(Toast)
Vue.use(Notify)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(VueAwesomeSwiper)
Vue.use(Slider)
Vue.use(Lazyload)
Vue.use(Overlay)

// 添加VueLazyload 选项
Vue.use(VueLazyload, {
    preLoad: 1.3,
    loading: require('./assets/images/loading-bars.svg'),
    attempt: 1
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    data: function () {
        return {
            baseUrl: 'http://wfpt.smartjinsha.com', // 切换中英文用===
            linkUrl: 'http://wfpt.smartjinsha.com/uploadfiles' // 此处加的公共变量是5号坑的所有跳转链接
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js